import request from "../utils/request";

export const getBulletins = '/bulletin/';

export function getBulletinsList(params:any){
    return request.get('/bulletin/list', {params});
}


export function modifyBulletin(data: any) {
    return request.request({
        url: '/bulletin/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function publishBulletin(bulletinId: number) {
    return request.request({
        url: '/bulletin/publish',
        method: 'post',
        data: {bulletinId}
    })
}

export function deleteBulletin(bulletinId: number) {
    return request.request({
        url: '/bulletin/',
        method: 'delete',
        params: {bulletinId}
    })
}